import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {BrokerDTO} from '../models/broker/BrokerDTO';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';

@Injectable({
  providedIn: 'root'
})
export class BrokerService {
  private url = environment.baseUrl + '/broker';

  constructor(private http: HttpClient) {
  }

  getListOfBrokers(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<BrokerDTO>> {
    return this.http.post<PagedResponseDTO<BrokerDTO>>(`${this.url}/filter`, pagedRequestDTO);
  }

  getBrokerById(id: number): Observable<BrokerDTO> {
    return this.http.get<BrokerDTO>(`${this.url}/${id}`);
  }

  getBrokerByNumber(number: string): Observable<BrokerDTO> {
    return this.http.get<BrokerDTO>(`${this.url}/get-by?number=${number}`);
  }

  saveBroker(broker: BrokerDTO): Observable<BrokerDTO> {
    return this.http.post<BrokerDTO>(this.url, broker);
  }

  deleteBrokerBy(brokerId: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${brokerId}`);
  }
}
